import { Components, Theme } from '@mui/material';

export const MuiCardContent: Components<
  Omit<Theme, 'components'>
>['MuiCardContent'] = {
  styleOverrides: {
    root: ({ theme }) => {
      return {
        backgroundColor: theme.palette.surfaceContainer.container,
        color: theme.palette.surface.onSurface,

        '&::-webkit-scrollbar': {
          backgroundColor: 'transparent',
        },
      };
    },
  },
};
